import 'sass/app.scss';

import _ from 'lodash';
import React from 'react';
import { ToastContainer } from 'react-toastify';
import { FooterLinks } from '../footer/footer-links';
import Footer from '../footer';
import {Link} from 'react-router-dom';

const TopNav = () => {
    //TODO: Replace with environment variable later
    let fansActive = false;
	return (
        <div className="guttered grid-x align-top align-spaced">
            <div className="columns small-1">
			    <a href='/#/main'><div className="logo" style={{transform:'scale(0.6)'}}></div></a>
            </div>
            <div className="columns large">
                <nav className="sign-up-nav">
                    <a href="mailto:info@muzado.com">Contact</a>&nbsp;&nbsp;
                    <a href="/login">Login</a>&nbsp;&nbsp;
                    <Link to={fansActive ? "/fan-sign-up" : "/coming-soon"}>
                        <button style={{fontSize: '1em', margin: '0', width: '8vw', padding: '0.2rem'}} className="add-button">
                            <div style={{margin: '2px'}}>Sign Up</div>
                        </button>
                    </Link>
                </nav>
            </div>
        </div>
	);
};


export class FanLanding extends React.Component {
	constructor (props) {
		super(props);
	}

	render() {
			// return <ArtistSignUpForm />;


		return (
			<div>
                <div className="top-nav">
				    <TopNav />
                </div>
				<ToastContainer />
                <div className="guttered">
                    <div id="section-1" className="hero-crowd segment-1 fade-section margin-bottom-2">
                        <div className="funbox">
                            <p className="wumbo">Own Your Music</p>
                            <p className="mini">
                            The magic of music lives in the bond between artist and fan.<br/>
                            Back when you bought a record, you weren’t just playing songs — you were holding a piece of the story.<br/>
                            Streaming broke that. Muzado brings it back.<br/>
                            <br/>
                            This isn’t a rental.<br/>
                            You discover it.<br/>
                            You download it.<br/>
                            You keep it. Forever.
                            </p>
                        </div>
                    </div>
                    <div id="section-2" className="f-segment-2 margin-bottom-2 margin-top-2">
                        <div className="container-row">
                            
                            <div className="contentbox">
                                <div className="fan-cutout1 fs2-img"/>
                            </div>
                            <div className="contentbox" style={{left:'42vw', top:'15vh', position:'absolute'}}>
                                <div className="title lite">Subscribe. Curate. Keep.</div>
                                <div className="paragraph lite">
                                    On Muzado, you don’t stream music — you own it.<br/>
                                    Subscribe to your favorite artists and unlock access to everything they release: full tracks, exclusives, behind-the-scenes gems, and more.<br/>
                                    <br/>
                                    You get downloads on your terms — no buffering, no expiration, no platform strings attached.<br/>
                                    <br/>
                                    Build a personal catalog that’s actually yours.<br/>
                                    Even if you unsubscribe, the music stays with you.<br/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="section-3" className="f-segment-3 margin-bottom-2 margin-top-2">
                        <div className="container-row">
                            <div className="contentbox-2"  style={{left:'4vw', top:'25vh'}}>
                                <div className="title">Instant Drops, On Your Terms</div>
                                <div className="paragraph">
                                No more waiting for streaming platforms to catch up or relying on playlists to find new music.<br/>
                                <br/>
                                When artists you subscribe to release something, it’s available right here — ready for you to download and keep.<br/>
                                <br/>
                                No delays. No extra steps.<br/>
                                <br/>
                                Just new music, when you want it — yours to hold onto, forever.<br/>
                                </div>
                            </div>
                            <div className="contentbox-3">
                                <div className="fan-cutout2 fs3-img"/>
                                <div className="diag-bubbles fs3-bgimg"/>
                            </div>
                        </div>
                    </div>
                    {/* <div id="section-5" className="f-segment-5 margin-bottom-2 margin-top-2">
                        <div className="row expanded">
                        <div className="fan-splash s5-img column large-4">
                            <div className="splash-edge s5-blocks"/>
                        </div>
                            <div className="column large-5 adjust-right" style={{paddingTop: '20vh', marginLeft:'9vw'}}>
                                <div className="title">The Digital Music Store</div>
                                <br/>
                                <div className="paragraph">
                                Remember the thrill of flipping through vinyl and CDs at your favorite record store, uncovering hidden gems and reliving cherished memories? That nostalgic experience comes to life - digitally. Rediscover the joy of music as you once did in those aisles—every song is a story, and every listen a journey.   
                                </div>
                            </div>
                        </div>
                    </div> */}
                    <div id="section-4" className="f-segment-4 margin-bottom-2 margin-top-2">
                        <div id="section-6" className="f-segment-6">
                            <div className="container-row">
                                <div className="contentbox-2"  style={{left:'4vw', top:'20vh'}}>
                                    <div className="title">One Artist. One Price. One Year.</div>
                                    <br/>
                                    <div className="paragraph">
                                    It’s simple: $9.99 per artist, once a year.<br/>
                                    <br/>
                                    No monthly bills. No hidden fees. No surprise charges.<br/>
                                    <br/>
                                    Just full access to their catalog, instant drops, and downloads you keep — all for less than a t-shirt.<br/>
                                    <br/>
                                    Support the music you love, without the hassle.
                                    </div>
                                </div>
                                <div className="contentbox-3">
                                    <div className="fan-splash2 fs6-img">
                                        <div className="splash-ripple fs6-bgimg"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="f-segment-btm margin-top-2 margin-bottom-2">
                            <div className="row expanded">
                                <div className="hand-cutout s4-img column large-4"/>
                                <div className="bg-squares s4-blocks"/>
                                <div className="column large-5 margin-left-2 adjust-right" style={{paddingTop: '10vh', zIndex: '200'}}>
                                    <div className="title">Where Music Meets Fair Support</div>
                                    <br/>
                                    <div className="paragraph">
                                    Every subscription does more than unlock music — it directly supports the artists you love.<br/>
                                    <br/>
                                    Your $9.99 isn’t just access — it’s recognition. It’s respect. It’s fuel for what comes next.<br/>
                                    <br/>
                                    When you subscribe, you’re not just listening.<br/>
                                    You’re part of the artist’s story.<br/>
                                    <br/>
                                    Support artists the way they deserve to be supported.<br/>
                                    <br/>
                                    And enjoy the music like it’s meant to be enjoyed — yours.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
               
                <div className="wide-footer">
                    <Footer />
                </div>
            </div>
		);
	}
}

export default FanLanding;
